// extracted by mini-css-extract-plugin
export default {"recruiterCard":"k6NtVwkrBLTfXQPt7IeZ","leftSide":"wg1DC5zFiPtkzsJxLSv_","rightSide":"PrM8oiQVmu8dfgjPxI60","title":"Mf76biWIuW4RdrSnV7kA","content":"YTeIRFs1X3xcoRAj18Do"};